import {ACTION_TYPE} from "utils/constants";

export const undo = info => ({
  type: ACTION_TYPE.UNDO,
  payload: info,
});

export const redo = info => ({
  type: ACTION_TYPE.REDO,
  payload: info,
});

export const toggleUndoAble = bool => ({
  type: ACTION_TYPE.TOGGLE_UNDO_ABLE,
  payload: bool,
});

export const toggleRedoAble = bool => ({
  type: ACTION_TYPE.TOGGLE_REDO_ABLE,
  payload: bool,
});
